import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import metadata from 'libphonenumber-js/metadata.max.json'; // Import metadata directly

// A smart wrapper that handles Formik integration and strict limiting automatically
const SmartPhoneInput = ({
    field, // { name, value, onChange, onBlur }
    form: { setFieldValue, setFieldTouched, errors, touched },
    label,
    ...props
}) => {
    // Dynamic maxLength state to prevent typing overflow
    const [maxLength, setMaxLength] = React.useState(15);
    const [dialCodeLength, setDialCodeLength] = React.useState(2); // default to 2

    // Helper function to get max length from metadata
    const getMaxLength = (iso2) => {
        const country = metadata.countries[iso2];
        if (!country) return 15; // default fallback

        // Index 3 contains possible lengths array in metadata format
        const lengths = country[3];
        if (!lengths) return 15;

        return Math.max(...lengths);
    };

    const handleChange = (value, countryData) => {
        const dialCode = countryData.dialCode;
        // Default to 'IN' if countryCode is missing, ensure uppercase
        const iso2 = (countryData.countryCode || 'IN').toUpperCase();

        const dynamicMax = getMaxLength(iso2);
        // Update the maxLength state dynamically
        setMaxLength(dynamicMax);
        setDialCodeLength(dialCode.length);

        // Remove everything except digits
        const digitsOnly = value.replace(/\D/g, '');

        // Extract national number (remove dial code from beginning)
        // value from react-phone-input-2 starts with dialCode
        let national = digitsOnly.slice(dialCode.length);

        // HARD trim removed to allow "Too long" validation error to show
        // if (national.length > dynamicMax) {
        //     national = national.slice(0, dynamicMax);
        // }

        // Reconstruct value with dialCode
        const finalValue = '+' + dialCode + national;

        // Update Formik state
        setFieldValue(field.name, finalValue);

        // Mark as touched immediately
        setFieldTouched(field.name, true, true);
    };

    const isError = errors[field.name] && touched[field.name];

    return (
        <div className="flex flex-col w-full">
            <div
                className={`flex items-center w-full rounded-md border bg-white h-[48px]
                ${isError ? 'border-red-600' : 'border-[#e0e0e0]'}
                focus-within:border-[#6A64F1]`}
            >
                <PhoneInput
                    country={'in'}
                    value={field.value || ''}
                    onChange={handleChange}
                    enableSearch={true}
                    // disableSearchIcon={true} // User removed this from their updated code
                    countryCodeEditable={false}
                    enableLongNumbers={false}   // 🔥 VERY IMPORTANT: prevents built-in length overrides
                    // dynamic inputProps
                    inputProps={{
                        name: field.name,
                        onBlur: field.onBlur,
                        maxLength: maxLength + (dialCodeLength || 2) + 15 // Increased buffer to allow "too long" error to show
                    }}
                    // containerClass, inputClass, buttonClass, dropdownClass are missing in user snippet
                    // but they were present before. I will re-add them to keep styling consistent with project
                    // unless user explicitly wants them removed. The user's snippet shows "..." 
                    // implying existing props should be preserved or new props added.
                    // However, the snippet explicitly has a different wrapping div structure.
                    // I will stick CLOSELY to user snippet but restore the styling classes 
                    // because otherwise the UI will break.

                    searchClass="search-class"
                    searchStyle={{ margin: '0', width: '90%', height: '30px' }}

                    containerClass="!border-none !shadow-none !w-full !h-full"
                    inputClass="!w-full !h-full !border-none !shadow-none !bg-transparent !text-base !font-medium !text-[#6B7280] !pl-[48px] !pr-3 !outline-none"
                    buttonClass="!bg-transparent !border-none"
                    dropdownClass="!shadow-lg !border-gray-200 !rounded-md"

                    {...props}
                />
            </div>

            {isError && (
                <div className="text-sm font-semibold text-red-500 pt-1">
                    {errors[field.name]}
                </div>
            )}
        </div>
    );
};

export default SmartPhoneInput;
